import { Badge } from '@ksyos/design-system';
import type { IRequest } from './getStatusLabel';
import { translateKey } from '../../translate';
import { getStatusLabel } from './getStatusLabel';

interface IStatusLabelProps {
    badge?: boolean;
    request: IRequest;
}

export function StatusLabelManager(props: IStatusLabelProps) {
    const label = getStatusLabel(props.request);
    let value = null;
    if (label) {
        const status = translateKey(`StatusLabelEnum.${label}`);
        if (props.badge) {
            value = <Badge text={status} />;
        } else {
            value = <>{status}</>;
        }
    }

    return value;
}
